import React, { Component } from "react";
import PropTypes from "prop-types";

import * as creds from "../../utils/creds";

export default class ReLogin extends Component {
  logout(e) {
    e.preventDefault();
    creds.logout();
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        {children} Please{" "}
        <a href="#" onClick={this.logout}>
          re-login
        </a>{" "}
        to continue working.
      </div>
    );
  }
}

ReLogin.propTypes = {
  children: PropTypes.node
};
